import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const Overline = ({ children, light = false }) => (
  <p
    className={`text-xs sm:text-sm uppercase tracking-[0.25em] font-semibold ${
      light ? "text-accent" : "text-primary"
    }`}
  >
    {children}
  </p>
);
